import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-loader',
  templateUrl: './system-loader.component.html',
})
export class SystemLoaderComponent {
  @Input() loader: boolean = false;

  constructor() {}
}
